import { Component, OnInit, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { CityView, SearchCityParameters } from '@api-proxies';
import { CityService } from '@services/http/clients/city.service';
import { GenericTypeAheadDropdownComponent } from 'ngx-lib';
import { FormEditorBase, createValueAccessorProvider } from '../base/form-editor-base';

@Component({
    selector: 'app-city-form-editor',
    templateUrl: './city-form-editor.component.html',
    styleUrls: ['./city-form-editor.component.scss'],
    providers: [createValueAccessorProvider(CityFormEditorComponent)],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [GenericTypeAheadDropdownComponent]
})
export class CityFormEditorComponent extends FormEditorBase<CityView[]> implements OnInit {
    value = input<CityView[]>();
    readonly = input<boolean>(false);
    placeholderText = input<string>('Select City');
    labelText = input<string>('City');
    countryId = input<number | undefined>();
    stateId = input<number | undefined>();

    private readonly cityService = inject(CityService);

    constructor() {
        super();
    }

    ngOnInit(): void {
        this.items.set([]);
    }

    selectedItem(): CityView | undefined {
        const items = this.selectedItems();
        return items && items.length > 0 ? items[0] : undefined;
    }

    onSelectedItemChange(item?: CityView): void {
        if (item) {
            this.onSelectedItemsChange([item]);
        } else {
            this.onSelectedItemsChange([]);
        }
    }

    protected override async onEntityTextChange(text: string): Promise<void> {
        if (!text) {
            this.items.set([]);
            return;
        }

        const cities = await this.cityService.search({
            filterText: text,
            countryId: this.countryId(),
            stateId: this.stateId()
        } as SearchCityParameters);

        this.items.set(cities);
    }

    protected override mapSelectedItemsToValue(): CityView[] {
        return this.selectedItems() || [];
    }

    protected override mapValueToSelectedItems(value: CityView[]): any[] {
        return value || [];
    }
}
